import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, Form, Button, Alert } from 'react-bootstrap';
import { QRCode } from 'react-qrcode-logo';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { store } from 'react-notifications-component';

import Deposits from './deposits.js'
import CryptoMethod from './cryptoMethod'
import WirebitMethod from './wirebitMethod'
import { get_address } from '../api.js'

import CopyClipboard from '../assets/copy-clip.png';
import WirebitTransfer from '../assets/wirebit_transfer.svg'
import CryptoRedP from '../assets/crypto.png'

function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

 const statusTranslate={
   cancelled:'cancelada',
   pending:'pendiente',
   completed:'completada',
   incomplete:'incompleta'
 }


const methodOptions = [
  {
    name:'Wirebit Transfer',
    description:'Transferencia al instante',
    navTo:'WirebitTransfer',
    internal:'True',
    svg:<img src={WirebitTransfer} style={{width:40, height:40, objectFit:'contain'}}/>,
    id:1
  },
  {
    name:'Crypto Red',
    description:'De 10 a 30 min de espera',
    navTo:'CryptoTransfer',
    internal:'False',
    svg:<img src={CryptoRedP} style={{width:40, height:40, objectFit:'contain'}}/>,
    id:2
  },
]

class Pending extends Component {
  constructor(props){
    super(props);
    let email = (this.props.email != '-')? this.props.email : ''
    this.state = {
      coin:this.props.coin || '',
      networks: this.props.networks,
      net:"",
      email,
      new_address:'',
      internal:(this.props.status == 'pending')?'True':'False'
    }
  }
  componentDidMount(){
    if(this.state.coin) this.coinSelected(this.state.coin)
  }


  addNotification(){
    store.addNotification({
      title: this.props.translations.checkout.notifications.copy.title,
      message: this.props.translations.checkout.notifications.copy.message,
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 1800,
        onScreen: true
      }
    });
  }

  addError(){
    this.setState({coin:''})
    store.addNotification({
      title: this.props.translations.checkout.notifications.error.title,
      message: this.props.translations.checkout.notifications.error.message,
      type: "danger",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 1800,
        onScreen: true
      }
    });
  }

  methodSelected(internal){
    this.setState({internal})
    if(this.state.coin) this.coinSelected(this.state.coin)
  }

  handleNetworkOnChange(net){
    if (net != "") {
      this.setState({net})
      this.coinSelected(this.state.coin)
    }
  }

  coinSelected(i){
    const self = this;
    let coin = i;
    this.setState({
      coin,
      loading:true,
      amount_coin:'',
      new_address:''
    }, async ()=>{
      let addressResponse = await get_address({...self.props,...self.state})
      if(addressResponse.status.code == '18007') return self.addError()
      let info = addressResponse.payload
      // let link = info.url

      var link = 'wirebit.com';
      if(info.url){
        link = info.url
      }else{
        link = 'https://wirebit.com/wallets?alias='+ info.group_nick +'&wallet='+info.wallet_alias+'&amount='+ Number(info.amount_coin).toFixed(8) +'&description='+this.props.reference+'&currency='+coin
        let navLink = 'wallets?alias='+ info.group_nick +'&wallet='+info.wallet_alias+'&amount='+ Number(info.amount_coin).toFixed(8) +'&description='+this.props.reference+'&currency='+coin
        self.setState({...addressResponse.payload, link, navLink, loading:false})
      }

      self.setState({...addressResponse.payload, link, loading:false})
    })
  }

  renderCart(products){
    return products.map((i)=>
      <tr>
        <td className='medium-dms gray-text'>
          {i.name}
        </td>
        <td className='medium-dms gray-text'>
          {i.quantity}
        </td>
        <td className='medium-dms gray-text rtext'>
          {formatMoney(i.usd || i.mxn)} {this.props.currency}
        </td>
      </tr>
    )
  }

  renderMethods(){
    let internal = this.state.internal
    return methodOptions.map((item, i) => {
      let active = (item.internal == internal)
      let name = "";
      let desc = "";
      if (item.navTo=='WirebitTransfer'){
        name = this.props.translations.checkout.pending.wirebit_method_name
        desc = this.props.translations.checkout.pending.wirebit_method_desc
      }
      else{
        name = this.props.translations.checkout.pending.crypto_method_name
        desc = this.props.translations.checkout.pending.crypto_method_desc

      }
      return(
        <button
          key={item.id}
          onClick={()=> this.methodSelected(item.internal) }
          className={'methodOption' + (active?' selected':'')}
          >

          <div style={{width:40, height:40, alignItems:'center'}}>
            {item.svg}
          </div>
          <div style={{height:'100%', width:1, marginLeft:10, marginRight:10, backgroundColor:'#6587FF'}}/>

          <div style={{flex:1,justifyContent:'space-between'}}>
            <p style={{textAlign:'left',fontSize:14,color:'#454CF5', fontWeight:'bold', marginBottom:0}}>{name}</p>
            <p style={{textAlign:'left',fontSize:12,color:'#6E6E6E', marginBottom:0}}>{desc}</p>
          </div>
        </button>
      )
    })
  }

  renderCoins(){
    let coins = this.props.coins
    if(!coins) return null
    return coins.map((i) => {
      let active = (i.coin == this.state.coin)
      return(
        <Button
          onClick={()=> this.coinSelected(i.coin) }
          className={'ecomm-coin-button flex space-between' + (active?' selected':'')}
          >
          <img  height="40" src={require("../../../CryptoIcons/" + i.coin + ".svg")}/>
          <span>{i.coin_name || i}</span> <span>{i.coin}</span>
        </Button>
      )
    })
  }

  render(){
    let { minutes, seconds } = this.props
    let  { products }  = this.props.cart
    return(
      <>
        <Row>

          <Col lg={6}>
            <div className='container-transactions'>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span className='medium-dms dark-text font-20'>{this.props.translations.checkout.pending.order_details_title}</span>
                <div style={{borderRadius:100, height:50, width:50, display:'inline-block', overflow:'hidden', position:'relative'}}>
                  {
                    this.props.img_b64 &&
                    <Image src={'data:image/png;base64,'+this.props.img_b64} style={{height:50, width:50}}/>
                  }
                </div>
              </div>
              <div style={{marginBottom:40}}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>{this.props.translations.checkout.pending.email_input}</Form.Label>
                  <Form.Control
                    placeholder={this.props.translations.checkout.pending.email_placeholder}
                    type="email"
                    value={this.state.email}
                    onChange={(e)=>this.setState({email:e.target.value})}
                    />
                </Form.Group>
              </div>
              <p className='order-id checkout'>{this.props.translations.checkout.pending.order} #{this.props.reference} <span style={{float:'right'}} className={this.props.status + ' tag'}>{this.props.translations.checkout.status[this.props.status]}</span></p>
              {
                products &&
                <div style={{maxHeight:'403px', overflow:'auto', marginTop:20, marginBottom:20}}>
                  <table style={{width:'100%', tableLayout:'fixed'}}>
                    <tr>
                      <th className='medium-dms dark-text'>
                        {this.props.translations.checkout.pending.column_title_product}
                      </th>
                      <th className='medium-dms dark-text'>
                        {this.props.translations.checkout.pending.column_title_quantity}
                      </th>
                      <th className='medium-dms dark-text rtext'>
                      {this.props.translations.checkout.pending.column_title_price} {this.props.currency}
                      </th>
                    </tr>
                    {this.renderCart(products)}
                  </table>
                </div>
              }
              <p className='checkout-total-text'>
                {this.props.translations.checkout.pending.order_total}
                <span>
                  {formatMoney(this.props.cart.total)} {this.props.currency}
                </span>
              </p>

            </div>
          </Col>


          <Col lg={6}>
            <div className='container-transactions'>
              <p className='medium-dms dark-text font-20'>{this.props.translations.checkout.pending.payment_title}</p>

              {
                this.props.status =='pending' && <p className='dark-text medium-dms' style={{textAlign:'right', marginBottom:-18}} >{minutes + ':' + this.renderSeconds(seconds)}</p>
              }

              {
                this.props.status =='pending' &&
                <>

                  <p className='dark-text medium-dms'>{this.props.translations.checkout.pending.payment_method_title}</p>
                  <div className='flex justify-start wrap'style={{width:'100%', marginLeft:-5, marginRight:-5}}>
                    {this.renderMethods()}
                  </div>


                  <p className='dark-text medium-dms' >{this.props.translations.checkout.pending.payment_crypto_title}</p>
                  <div className='flex wrap justify-start' style={{width:'100%', marginLeft:-5, marginRight:-5}}>
                    {this.renderCoins()}
                  </div>

                  <div className='ecommerce_divider'/>
                </>
              }
              {
                (this.state.internal == 'False')
                ? <CryptoMethod {...this.state} translations={this.props.translations} addNotification={()=>this.addNotification()} handleNetworkOnChange={(net)=>this.handleNetworkOnChange(net)} />
                : <WirebitMethod {...this.state} translations={this.props.translations} addNotification={()=>this.addNotification()} />
              }

              <div style={{textAlign:'center'}}>
                <Button className="ecomm-button" onClick={()=>this.props.changeStatus(true)}>{this.props.translations.checkout.pending.payment_made}</Button>
              </div>
            </div>
          </Col>

        </Row>
            {
              (this.props.status == 'incomplete') &&
              <Deposits {...this.props} addNotification={()=>this.addNotification()}/>
            }
      </>
    )
  }

  renderSeconds(seconds){
    if(seconds =='--') return seconds
    if(seconds < 10)
      return '0'+seconds
    else
      return seconds
  }
}export default Pending
